import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { TuiAlertModule, TuiRootModule } from '@taiga-ui/core';
import { TUI_SANITIZER } from '@taiga-ui/core';
import { NgDompurifySanitizer } from '@tinkoff/ng-dompurify';
import { ValErrorComponent } from './val-error/val-error.component';
import { ErrorsInterceptor } from './shared/interceptors/errors.interceptor';
import { ProfileComponent } from './profile/profile.component';
import { FormWrapperComponent } from './form-wrapper/form-wrapper.component';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { PasswordResetFormComponent } from './password-reset-form/password-reset-form.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { PageWrapperComponent } from './page-wrapper/page-wrapper.component';
import { ButtonComponent } from './button/button.component';
import { LoaderComponent } from './loader/loader.component';
import { ExternalLoginComponent } from './external-login/external-login.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { LayoutModule } from '@angular/cdk/layout';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';
import { AutofocusDirective } from './shared/directives/autofocus.directive';
import { TranslocoRootModule } from './transloco-root.module';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    ValErrorComponent,
    ProfileComponent,
    FormWrapperComponent,
    EmailConfirmationComponent,
    PasswordResetFormComponent,
    PasswordResetComponent,
    PasswordChangeComponent,
    PageWrapperComponent,
    ButtonComponent,
    LoaderComponent,
    ExternalLoginComponent,
    ErrorPageComponent,
    CheckboxComponent,
    CookieConsentComponent,
    UserAvatarComponent,
    AutofocusDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    TuiRootModule,
    TuiAlertModule,
    LayoutModule,
    TranslocoRootModule
  ],
  providers: [
    { provide: TUI_SANITIZER, useClass: NgDompurifySanitizer },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
